














import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class NavMenu extends Vue {
  @Prop({ default: [] }) navMenu!: any[]

  get menu() {
    return this.navMenu
  }
}
